const bindings = [
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'Zoom' },
    label: 'Zoom',
    keys: ['z'],
    isEditable: true,
  },
  {
    commandName: 'scaleUpViewport',
    label: 'Aumentar Zoom',
    keys: ['+'],
    isEditable: true,
  },
  {
    commandName: 'scaleDownViewport',
    label: 'Diminuir Zoom',
    keys: ['-'],
    isEditable: true,
  },
  {
    commandName: 'fitViewportToWindow',
    label: 'Ajustar à tela',
    keys: ['='],
    isEditable: true,
  },
  {
    commandName: 'rotateViewportCW',
    label: 'Girar à direita',
    keys: ['r'],
    isEditable: true,
  },
  {
    commandName: 'rotateViewportCCW',
    label: 'Girar à esquerda',
    keys: ['l'],
    isEditable: true,
  },
  {
    commandName: 'flipViewportHorizontal',
    label: 'Flip Horizontal',
    keys: ['h'],
    isEditable: true,
  },
  {
    commandName: 'flipViewportVertical',
    label: 'Flip Vertical',
    keys: ['v'],
    isEditable: true,
  },
  {
    commandName: 'toggleCine',
    label: 'Cine',
    keys: ['m'],
  },
  {
    commandName: 'toggleSynchronizer',
    commandOptions: { type: 'imageSlice' },
    label: 'Sincronizar séries',
    keys: ['t'],
    isEditable: true,
  },
  
  {
      commandName: 'clearMeasurements',
      label: 'Apagar todas as medidas',
      keys: ['ctrl+d'],
      isEditable: true,
    },

  {
    commandName: 'invertViewport',
    label: 'Inverter',
    keys: ['i'],
    isEditable: true,
  },
  {
    commandName: 'incrementActiveViewport',
    label: 'Próximo Viewport',
    keys: ['right'],
    isEditable: true,
  },
  {
    commandName: 'decrementActiveViewport',
    label: 'Viewport Anterior',
    keys: ['left'],
    isEditable: true,
  },
  {
    commandName: 'updateViewportDisplaySet',
    commandOptions: {
      direction: -1,
    },
    label: 'Série Anterior',
    keys: ['pageup'],
    isEditable: true,
  },
  {
    commandName: 'updateViewportDisplaySet',
    commandOptions: {
      direction: 1,
    },
    label: 'Próxima Série',
    keys: ['pagedown'],
    isEditable: true,
  },
  {
    commandName: 'nextStage',
    context: 'DEFAULT',
    label: 'Próximo Stage',
    keys: ['.'],
    isEditable: true,
  },
  {
    commandName: 'previousStage',
    context: 'DEFAULT',
    label: 'Stage Anterior',
    keys: [','],
    isEditable: true,
  },
  {
    commandName: 'nextImage',
    label: 'Próxima Imagem',
    keys: ['down'],
    isEditable: true,
  },
  {
    commandName: 'previousImage',
    label: 'Imagem anterior',
    keys: ['up'],
    isEditable: true,
  },
  {
    commandName: 'firstImage',
    label: 'Primeira Imagem',
    keys: ['home'],
    isEditable: true,
  },
  {
    commandName: 'lastImage',
    label: 'Última Imagem',
    keys: ['end'],
    isEditable: true,
  },
  {
    commandName: 'resetViewport',
    label: 'Restaurar',
    keys: ['space'],
    isEditable: true,
  },
  {
    commandName: 'cancelMeasurement',
    label: 'Cancelar medida',
    keys: ['esc'],
  },
  {
    commandName: 'setWindowLevelPreset',
    commandOptions: { presetName: 'ct-soft-tissue', presetIndex: 0 },
    label: 'Janela Preset 1',
    keys: ['1'],
  },
  {
    commandName: 'setWindowLevelPreset',
    commandOptions: { presetName: 'ct-lung', presetIndex: 1 },
    label: 'Janela Preset 4',
    keys: ['4'],
  },
  {
    commandName: 'setWindowLevelPreset',
    commandOptions: { presetName: 'ct-bone', presetIndex: 2 },
    label: 'Janela Preset 2',
    keys: ['2'],
  },
  {
    commandName: 'setWindowLevelPreset',
    commandOptions: { presetName: 'ct-brain', presetIndex: 3 },
    label: 'Janela Preset 3',
    keys: ['3'],
  },
  {
    commandName: 'acceptPreview',
    label: 'Accept Preview',
    keys: ['enter'],
  },
  {
    commandName: 'rejectPreview',
    label: 'Reject Preview',
    keys: ['esc'],
  },
  {
    commandName: 'undo',
    label: 'Desfazer',
    keys: ['ctrl+z'],
    isEditable: true,
  },
  {
    commandName: 'setViewportOrientation',
    commandOptions: { orientation: 'axial' },
    label: 'Orientação Axial',
    keys: ['a'],
    isEditable: true,
  },
  {
    commandName: 'setViewportOrientation',
    commandOptions: { orientation: 'sagittal' },
    label: 'Orientação Sagital',
    keys: ['x'],
    isEditable: true,
  },
  {
    commandName: 'setViewportOrientation',
    commandOptions: { orientation: 'coronal' },
    label: 'Orientação Coronal',
    keys: ['c'],
    isEditable: true,
  },
  {
    commandName: 'redo',
    label: 'Refazer',
    keys: ['ctrl+y'],
    isEditable: true,
  },
  // {
  //   commandName: 'interpolateScrollForMarkerLabelmap',
  //   label: 'Interpolate Scroll',
  //   keys: ['n'],
  //   isEditable: true,
  // },
  // {
  //   commandName: 'increaseBrushSize',
  //   label: 'Increase Brush Size',
  //   keys: [']'],
  //   isEditable: true,
  // },
  // {
  //   commandName: 'decreaseBrushSize',
  //   label: 'Decrease Brush Size',
  //   keys: ['['],
  //   isEditable: true,
  // },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'CircularEraser' },
    label: 'Eraser',
    keys: ['g'],
    isEditable: true,
  },
  // {
  //   commandName: 'setToolActive',
  //   commandOptions: { toolName: 'CircularBrush' },
  //   label: 'Brush',
  //   keys: ['b'],
  //   isEditable: true,
  // },
  // {
  //   commandName: 'addNewSegment',
  //   label: 'Add New Segment',
  //   keys: ['a'],
  //   isEditable: true,
  // },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'Zoom' },
    label: 'Zoom',
    keys: ['z'],
    isEditable: true,
  },
    {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'Pan' },
    label: 'Pan',
    keys: ['p'],
    isEditable: true,
  },
  {
    commandName: 'setToolActiveToolbar',
    commandOptions: { toolName: 'EllipticalROI' },
    label: 'Elipse',
    keys: ['e'],
    isEditable: true,
  },
  {
    commandName: 'setToolActiveToolbar',
    commandOptions: { toolName: 'Length' },
    label: 'Tamanho',
    keys: ['d'],
    isEditable: true,
  },
  {
    commandName: 'setToolActiveToolbar',
    commandOptions: { toolName: 'WindowLevel' },
    label: 'Janelamento',
    keys: ['w'],
    isEditable: true,
  },
  {
    commandName: 'setToolActiveToolbar',
    commandOptions: { toolName: 'StackScroll' },
    label: 'Navegar Stacks',
    keys: ['s'],
    isEditable: true,
  },
  {
    commandName: 'setToolActiveToolbar',
    commandOptions: { toolName: 'ArrowAnnotate' },
    label: 'Anotação',
    keys: ['q'],
    isEditable: true,
  },
  {
    commandName: 'copyViewportImageToClipboard',
    commandOptions: { toolName: 'ArrowAnnotate' },
    label: 'Copiar imagem do viewport',
    keys: ['ctrl+c'],
    isEditable: true,
  },
];

export default bindings;
